import { useOptroImport } from "../contexts/optroImportContext";
import { ControlWithUser } from "../models/audit/control";
import { OptroControlSummary } from "../models/audit/optroSync";
import { useImportPlaceholders } from "./useImportPlaceholders";

// An imported control is linked by the same external ref the Optro listing
// shows, so one ref keys the status, the import item, and its real row.
const refOf = (summary: OptroControlSummary) => summary.externalRef;
const rowKeyOf = (control: ControlWithUser) =>
  control.externalRef?.externalRef ?? null;

interface UseImportingControlsArgs {
  controls: ControlWithUser[];
  loading: boolean;
  enabled: boolean;
  onItemLanded: () => void;
}

// The Optro controls of the current import that haven't landed in the
// Controls list yet, for placeholder rows, and the loaded list with
// unfinished rows held back. See useImportPlaceholders.
export const useImportingControls = ({
  controls,
  loading,
  enabled,
  onItemLanded,
}: UseImportingControlsArgs) => {
  const { placeholderJob, placeholderSummaries } = useOptroImport();
  const { visibleRows, importing } = useImportPlaceholders({
    job: placeholderJob,
    startItems: placeholderSummaries,
    rows: controls,
    reloadedLists: [controls],
    loading,
    enabled,
    onItemLanded,
    statusRefOf: refOf,
    itemKeyOf: refOf,
    rowKeyOf,
  });
  return {
    visibleControls: visibleRows,
    importingControls: importing,
  };
};
